import { dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType, setModalError } from 'dmpconnectjsapp-base/actions';
import commands                                                                                    from 'dmpconnectjsapp-base/actions/config/commands';
import { apiSections, dmpconnectActionConstants, vitaleCardMonitoringStatuses }                    from 'dmpconnectjsapp-base/constants';
import { apiErrors }                                                                               from 'dmpconnectjsapp-base/errors';
import { vitaleDataType }                                                                          from 'dmpconnectjsapp-base/helpers/vitaleData';
import { put, select, take, takeEvery }                                                                    from 'redux-saga/effects';
import env                                                                                         from '../../envVariables';
import { getAction }                                                                               from '../actions';
import { createModalError }                                                                        from '../errors';
import { errorActions }                                                                            from '../errors/errorActions';
import { errorTypes }                                                                              from '../errors/errorConfiguration';
import { patientDataToRawVitaleData }                                                              from '../helpers/vitaleCard';
import { b64DecodeUnicode, b64EncodeUnicode }                                                      from '../utils/dataUtils';

function * submitAAT ({
  patient,
  rightsHolder,
  soapBody,
  connectionHandle,
  vitaleCardIndex,
  vitaleType,
  isRemote
}) {
  
  let withRawData = false;
  const aatiConfig = yield select(({ dmpconnectAATiConfiguration }) => dmpconnectAATiConfiguration);
  
  if (vitaleType === vitaleDataType.VITALE_CARD) {
    // check vitale status
    yield put(getAction(
      commands.checkVitaleTokenStatus,
      apiSections.CHECK_VITALE_TOKEN_STATUS,
      null,
      {
        subSection: 'checkStatus',
      },
    ));
    
    // wait result vitale status
    const tokenResult = yield take([
      dmpCommandSuccessContextualizedType(apiSections.CHECK_VITALE_TOKEN_STATUS),
      dmpCommandFailureContextualizedType(apiSections.CHECK_VITALE_TOKEN_STATUS),
    ]);
    
    if (tokenResult && tokenResult.type === dmpCommandFailureContextualizedType(apiSections.CHECK_VITALE_TOKEN_STATUS)) {
      return;
    }
    const { data: { i_cardStatus, i_previousCardStatus } = {} } = tokenResult;
    
    if (i_cardStatus === vitaleCardMonitoringStatuses.noChange && i_previousCardStatus === vitaleCardMonitoringStatuses.newCard) {
      withRawData = false;
    } else if (
      i_cardStatus === vitaleCardMonitoringStatuses.NoCard ||
      (
        i_cardStatus === vitaleCardMonitoringStatuses.noChange && i_previousCardStatus === vitaleCardMonitoringStatuses.NoCard
      )
    ) {
      withRawData = true;
    } else {
      withRawData = -1;
    }
  }
  
  // emtpytlsirequest
    // if (isRemote) {
    // yield put(
    //   getAction(
    //     commands.generateEmptyTlsiRequestWithoutPatientData,
    //     apiSections.GENERATE_EMPTY_TLSI_REQUEST,
    //     {
    //       LpsInfos: {
    //         s_idam         : aatiConfig.idam,
    //         s_instance     : '550e8400-e29b-41d4-a716-446655440000',
    //         s_name         : aatiConfig.lpsName,
    //         s_numAM        : aatiConfig.numAm,
    //         s_version      : aatiConfig.lpsVersion,
    //       },
    //       s_service  : 'aat',
    //       s_version  : '4.4.0',
    //       s_operation: 'CreerFluxAAT',
    //       i_isDevMode: Number(env.REACT_APP_PRODUCTON_MODE) !== 1,
    //     },
    //     {
    //       contextExtra: {
    //         forceModal : true,
    //       },
    //     },
    //   ),
    // );
    //  yield put(
    //   getAction(
    //     commands.generateEmptyTlsiRequest,
    //     apiSections.GENERATE_EMPTY_TLSI_REQUEST,
    //     {
    //       LpsInfos: {
    //         s_idam         : aatiConfig.idam,
    //         s_instance     : '550e8400-e29b-41d4-a716-446655440000',
    //         s_name         : aatiConfig.lpsName,
    //         s_numAM        : aatiConfig.numAm,
    //         s_version      : aatiConfig.lpsVersion,
    //       },
    //       i_vitalePatientIndex: vitaleCardIndex,
    //       i_useApCvContext    :  1,
    //       s_service           : 'aat',
    //       s_version           : '4.4.0',
    //       s_operation         : 'CreerFluxAAT',
    //       i_isDevMode         : Number(env.REACT_APP_PRODUCTON_MODE) !== 1,
    //     },
    //     {
    //       contextExtra: {
    //         forceModal : true,
    //         forceAction: errorActions.READ_VITALE_CARD,
    //       },
    //     },
    //   ),
    // );
  if (withRawData === false && isRemote === false) {
    yield put(
      getAction(
        commands.generateEmptyTlsiRequest,
        apiSections.GENERATE_EMPTY_TLSI_REQUEST,
        {
          LpsInfos: {
            s_idam         : aatiConfig.idam,
            s_instance     : '550e8400-e29b-41d4-a716-446655440000',
            s_name         : aatiConfig.lpsName,
            s_numAM        : aatiConfig.numAm,
            s_version      : aatiConfig.lpsVersion,
          },
          i_vitalePatientIndex: vitaleCardIndex,
          i_useApCvContext    : vitaleType === vitaleDataType.APCV_CONTEXT ? 1 : 0,
          s_service           : 'aat',
          s_version           : '4.4.0',
          s_operation         : 'CreerFluxAAT',
          i_isDevMode         : Number(env.REACT_APP_PRODUCTON_MODE) !== 1,
        },
        {
          contextExtra: {
            forceModal : true,
            forceAction: errorActions.READ_VITALE_CARD,
          },
        },
      ),
    );
  } else if (withRawData === true || isRemote === true) {
    let rawVitaleData
    if (isRemote) {
      rawVitaleData = patientDataToRawVitaleData(patient, {s_nir: patient.s_nir});
    } else {
      rawVitaleData = patientDataToRawVitaleData(patient, rightsHolder);
    }
    yield put(
      getAction(
        commands.generateEmptyTlsiRequestWithRawVitaleData,
        apiSections.GENERATE_EMPTY_TLSI_REQUEST,
        {
          LpsInfos: {
            s_idam         : aatiConfig.idam,
            s_instance     : '550e8400-e29b-41d4-a716-446655440000',
            s_name         : aatiConfig.lpsName,
            s_numAM        : aatiConfig.numAm,
            s_version      : aatiConfig.lpsVersion,
          },
          ...rawVitaleData,
          s_service  : 'aat',
          s_version  : '4.4.0',
          s_operation: 'CreerFluxAAT',
          i_isDevMode: Number(env.REACT_APP_PRODUCTON_MODE) !== 1,
        },
        {
          contextExtra: {
            forceModal : true,
            forceAction: errorActions.READ_VITALE_CARD,
          },
        },
      ),
    );
  } 
 else {
    // TODO : ERROR
    const modalError = createModalError({
      i_apiErrorType: errorTypes.ApiErrors,
      i_apiErrorCode: apiErrors.VITALE_CHANGED,
    });
    yield put(setModalError(modalError));
    return;
  }
  // wait result emtpytlsirequest
  const emtpyRequestResult = yield take([
    dmpCommandSuccessContextualizedType(apiSections.GENERATE_EMPTY_TLSI_REQUEST),
    dmpCommandFailureContextualizedType(apiSections.GENERATE_EMPTY_TLSI_REQUEST),
  ]);
  
  if (emtpyRequestResult && emtpyRequestResult.type === dmpCommandSuccessContextualizedType(apiSections.GENERATE_EMPTY_TLSI_REQUEST)) {
    // sendhttprequest
    const { data: { s_answerBodyBuffer = '' } = {} } = emtpyRequestResult;
    const requestSkeleton                            = b64DecodeUnicode(s_answerBodyBuffer);
    // console.log('soapBody', soapBody);
    
    const fullRequest = requestSkeleton.replace('BODYCONTENTTOREPLACE', soapBody).replace(
      '<soap:Body>',
      '<soap:Body xmlns:cer="http://www.cnamts.fr/CertificatMedical" xmlns:urn3="urn:siram:avisarrettravail">',
    );
    yield put(
      getAction(
        commands.sendHttpRequest,
        apiSections.SEND_HTTP_REQUEST,
        {
          i_connectionHandle: connectionHandle,
          s_headersBase64   : b64EncodeUnicode(
            'Content-type:application/soap+xml;charset=utf-8',
          ),
          s_httpVerb        : 'POST',
          s_requestBase64   : b64EncodeUnicode(fullRequest),
          s_urlPath         : '/lps',
        },
      ),
    );
    // console.log(fullRequest);
  }
}

export const handleAATCallbacks = function * () {
  yield takeEvery(dmpconnectActionConstants.DMPC_SEND_AAT, submitAAT);
};
